import React from 'react';

import { registerDecoration } from 'core/forms';

import { Typo } from 'uikit/content';

const FormDecorationCharacterLimit = ({ schema: { limit, prefix } }) => (
  <>
    <Typo element="span" variant="s02">{prefix}</Typo>
    <Typo element="span" variant="s02" weight="medium">{limit}</Typo>
  </>
);

registerDecoration('CharacterLimit', React.memo(FormDecorationCharacterLimit));

export default FormDecorationCharacterLimit;
